var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSugarImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2916.77 2929.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{opacity:0.3;}.cls-3{fill:#91b3fa;}.cls-4{fill:#bdd0fb;}.cls-5{fill:#18174a;}.cls-6{opacity:0.76;}.cls-32,.cls-34,.cls-7,.cls-9{fill:#fff;}.cls-7{opacity:0.6;}.cls-8{opacity:0.64;}.cls-10{fill:url(#linear-gradient-2);}.cls-11{fill:url(#linear-gradient-3);}.cls-12{fill:url(#linear-gradient-4);}.cls-13{fill:url(#linear-gradient-5);}.cls-14{fill:url(#linear-gradient-6);}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:#7d97f4;}.cls-23{fill:url(#linear-gradient-14);}.cls-24{fill:url(#linear-gradient-15);}.cls-25{fill:url(#linear-gradient-16);}.cls-26{fill:url(#linear-gradient-17);}.cls-27{fill:url(#linear-gradient-18);}.cls-28{fill:url(#linear-gradient-19);}.cls-29{fill:url(#linear-gradient-20);}.cls-30{fill:url(#linear-gradient-21);}.cls-31{fill:#2b69b3;}.cls-32{fill-rule:evenodd;}.cls-33{fill:url(#linear-gradient-22);}.cls-34{opacity:0.52;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3101.56,
    y1: 3647.46,
    x2: 681.28,
    y2: 641.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 6983.54,
    y1: 2750.39,
    x2: 7034.4,
    y2: 2750.39,
    gradientTransform: "translate(-6545.85 -59.63) rotate(0.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 6800.25,
    y1: 2747.77,
    x2: 6844.16,
    y2: 2747.77,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 301.52,
    y1: 780.6,
    x2: 383.07,
    y2: 1361.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 7192.88,
    y1: 1423.54,
    x2: 7452.72,
    y2: 1423.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2243.04,
    y1: 1379.05,
    x2: 2417.4,
    y2: 1775.75,
    gradientTransform: "matrix(-1, -0.01, -0.01, 1, 3092.02, 32.86)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 7451.47,
    y1: 1247.87,
    x2: 7524.23,
    y2: 1136.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 43.04,
    y1: 816.88,
    x2: 124.59,
    y2: 1397.94,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 6624.3,
    y1: 1791.56,
    x2: 6953.12,
    y2: 1791.56,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 6876.8,
    y1: 1440.04,
    x2: 7006.81,
    y2: 1440.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -376.39,
    y1: 3055.07,
    x2: -424.97,
    y2: 2894.83,
    gradientTransform: "matrix(0.75, -0.66, 0.66, 0.75, -1250.54, -1181.73)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -426.05,
    y1: 3054.32,
    x2: -469.76,
    y2: 2910.15,
    gradientTransform: "matrix(0.75, -0.66, 0.66, 0.75, -1250.54, -1181.73)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 6627.93,
    y1: 1785.93,
    x2: 6730.73,
    y2: 1785.93,
    gradientTransform: "translate(-6273.84)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1773.49,
    y1: 2259.56,
    x2: 1215.18,
    y2: 2711.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1303.49,
    y1: 2382.23,
    x2: 1303.49,
    y2: 1620.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2114.16,
    y1: 1120.06,
    x2: 1852.51,
    y2: 1643.35,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 4075.04,
    y1: 1929.79,
    x2: 4044.43,
    y2: 1733.35,
    gradientTransform: "translate(-2484.06)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 2669.51,
    y1: 5981.97,
    x2: 2869.9,
    y2: 6118.08,
    gradientTransform: "translate(-2456.93 -3644.73) rotate(-12.36)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2661.54,
    y1: 5972.2,
    x2: 2861.93,
    y2: 6108.32,
    gradientTransform: "translate(-2456.93 -3644.73) rotate(-12.36)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 4200.43,
    y1: 2152.89,
    x2: 4626.47,
    y2: 2152.89,
    gradientTransform: "translate(-2484.06)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 4118.11,
    y1: 2387.4,
    x2: 3849.91,
    y2: 2460.9,
    gradientTransform: "translate(-2506.65 -75.48) rotate(-2.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 636.36,
    y1: 736.57,
    x2: 579.73,
    y2: 1321.02,
    gradientTransform: "translate(897.4 -132.97) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2435.73,2462.06c-55.6,58.53-108.2,96.27-149.76,126.09-488.52,350.52-1066.57,248.35-1189.42,223.4-181.42-36.85-532.09-108.07-785.62-406.22C-72.63,1954.27-12.91,1243.62,284.61,774.52,339,688.71,626.5,212.46,1210.78,136.08c353.6-46.22,765.78,47,1064.27,297.08C2901.61,958.1,2857,2018.55,2435.73,2462.06Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2174.6,620.39a9.48,9.48,0,0,1,1.86,12.55c-5.92,8.92-12.32,17.73-19,26.16a9.49,9.49,0,0,1-13.33,1.54l-.14-.12a9.48,9.48,0,0,1-1.39-13.21c6.36-8,12.44-16.38,18.06-24.86a9.49,9.49,0,0,1,13.15-2.66A9.81,9.81,0,0,1,2174.6,620.39Zm-53.07,63.33a10.09,10.09,0,0,1,.83.77,9.48,9.48,0,0,1-.3,13.41c-7.78,7.44-15.95,14.61-24.29,21.33a9.48,9.48,0,1,1-11.9-14.77c7.93-6.39,15.69-13.2,23.08-20.27A9.49,9.49,0,0,1,2121.53,683.72Zm-65.69,50.08a9.49,9.49,0,0,1-1.18,15.46c-9.21,5.51-18.79,10.68-28.45,15.38a9.48,9.48,0,1,1-8.29-17.06c9.17-4.46,18.26-9.37,27-14.6A9.49,9.49,0,0,1,2055.84,733.8Zm-75.26,34.14a9.48,9.48,0,0,1-3.13,16.33c-10.22,3.31-20.71,6.21-31.17,8.64a9.48,9.48,0,1,1-4.28-18.48c9.94-2.31,19.9-5.06,29.61-8.21A9.49,9.49,0,0,1,1980.58,767.94Zm-81,16.49a9.48,9.48,0,0,1-5.19,16.76c-10.68,1-21.55,1.47-32.3,1.52a9.49,9.49,0,0,1-.09-19c10.22,0,20.55-.53,30.7-1.44A9.48,9.48,0,0,1,1899.6,784.43ZM1817,782.6a9.49,9.49,0,0,1-7.29,16.73c-10.64-1.44-21.36-3.34-31.84-5.67a9.49,9.49,0,1,1,4.12-18.52c10,2.21,20.14,4,30.25,5.38A9.54,9.54,0,0,1,1817,782.6ZM1534.57,578.78a9.31,9.31,0,0,1,2.47,3.15c4.48,9.15,9.41,18.24,14.66,27a9.48,9.48,0,0,1-16.26,9.76c-5.54-9.23-10.73-18.79-15.44-28.44a9.49,9.49,0,0,1,14.57-11.47ZM1736.9,762.53a9.49,9.49,0,0,1-9.37,16.2c-10-3.76-20.07-8-29.76-12.62a9.48,9.48,0,1,1,8.14-17.13c9.21,4.38,18.72,8.41,28.27,12A9.39,9.39,0,0,1,1736.9,762.53ZM1579,648.46a9.65,9.65,0,0,1,1.35,1.36c6.41,7.93,13.25,15.68,20.32,23A9.48,9.48,0,0,1,1587,686c-7.45-7.76-14.65-15.92-21.39-24.26a9.48,9.48,0,0,1,13.4-13.29Zm84.33,76.6A9.49,9.49,0,0,1,1652,740.29c-9-5.92-17.77-12.29-26.2-19l-.15-.13a9.48,9.48,0,0,1,11.92-14.75c8,6.33,16.38,12.39,24.89,18C1662.76,724.65,1663,724.85,1663.29,725.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1510.87,516.53a9.42,9.42,0,0,1,3.09,4.75c1.32,4.71,2.76,9.47,4.28,14.15a9.48,9.48,0,1,1-18,5.85c-1.6-4.92-3.12-9.93-4.5-14.88a9.48,9.48,0,0,1,15.17-9.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1547.8,229.72a9.5,9.5,0,0,1,2.14,12.12c-2.48,4.21-4.91,8.55-7.23,12.89A9.49,9.49,0,1,1,1526,245.8c2.44-4.56,5-9.13,7.61-13.57a9.47,9.47,0,0,1,14.22-2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2101.33,131.46q5,4.17,10,8.53a9.49,9.49,0,1,1-12.56,14.22c-7.61-6.72-15.47-13.12-23.47-19.08a9.49,9.49,0,1,1,11.35-15.2C2091.58,123.61,2096.52,127.49,2101.33,131.46Zm45.16,44.18a9.5,9.5,0,0,1,1.16,1.13c6.91,8,13.55,16.41,19.75,25a9.48,9.48,0,1,1-15.35,11.13c-5.89-8.11-12.21-16.09-18.77-23.71a9.48,9.48,0,0,1,13.21-13.51ZM2044.66,92.92A9.49,9.49,0,0,1,2034,108.54c-8.77-4.84-17.87-9.37-27.06-13.46a9.49,9.49,0,0,1,7.73-17.33c9.67,4.31,19.25,9.08,28.49,14.18A9.45,9.45,0,0,1,2044.66,92.92Zm147.83,149.8a9.31,9.31,0,0,1,2.33,2.85c5,9.33,9.61,19,13.78,28.69a9.48,9.48,0,0,1-17.43,7.48c-4-9.22-8.36-18.39-13.09-27.25a9.48,9.48,0,0,1,14.41-11.77ZM1969.59,61.81a9.49,9.49,0,0,1-8.68,16.43c-9.62-2.79-19.49-5.21-29.35-7.19a9.48,9.48,0,1,1,3.73-18.59c10.38,2.08,20.77,4.62,30.9,7.56A9.47,9.47,0,0,1,1969.59,61.81Zm-80.09-13.9a9.48,9.48,0,0,1-6.61,16.79c-10-.62-20.2-.82-30.23-.61a9.48,9.48,0,1,1-.41-19c10.56-.23,21.26,0,31.81.64A9.38,9.38,0,0,1,1889.5,47.91Zm-81.2,3.9a9.49,9.49,0,0,1-4.55,16.68c-9.93,1.58-19.9,3.59-29.64,6a9.48,9.48,0,1,1-4.53-18.42c10.24-2.52,20.74-4.65,31.19-6.31A9.49,9.49,0,0,1,1808.3,51.81Zm-78.42,21.51a9.48,9.48,0,0,1-2.54,16.12c-9.34,3.71-18.63,7.86-27.6,12.34a9.48,9.48,0,1,1-8.47-17c9.45-4.72,19.23-9.09,29.06-13A9.5,9.5,0,0,1,1729.88,73.32Zm-71.81,38.22a9.61,9.61,0,0,1,1.79,2,9.48,9.48,0,0,1-2.47,13.18c-8.27,5.67-16.41,11.76-24.19,18.11a9.48,9.48,0,0,1-12-14.69c8.2-6.69,16.76-13.11,25.47-19.07A9.49,9.49,0,0,1,1658.07,111.54Zm-61.62,53,.44.39a9.47,9.47,0,0,1,.46,13.4c-5,5.41-10,11-14.68,16.73q-2.55,3.09-5,6.22a9.48,9.48,0,0,1-13.32,1.56,9.37,9.37,0,0,1-1.57-13.31q2.6-3.3,5.28-6.55c4.94-6,10.14-11.91,15.45-17.59A9.48,9.48,0,0,1,1596.45,164.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2222.65,318.49a9.51,9.51,0,0,1,3.1,4.8c1.36,4.95,2.64,10,3.81,15.08a9.48,9.48,0,1,1-18.48,4.27c-1.11-4.8-2.33-9.62-3.62-14.32a9.49,9.49,0,0,1,15.19-9.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2142.75,395.19a4.42,4.42,0,0,0-3-4.2l-50.91-17.88a235,235,0,0,0-28.72-70.52L2084,254.25a4.44,4.44,0,0,0-.83-5.08l-45.5-46a4.44,4.44,0,0,0-5.07-.88L1984,225.62a234.84,234.84,0,0,0-70.2-29.51L1896.53,145a4.43,4.43,0,0,0-4.17-3l-64.72-.36a4.44,4.44,0,0,0-4.21,3l-17.87,50.91A234.65,234.65,0,0,0,1735,224.23l-48.35-23.89a4.45,4.45,0,0,0-5.08.83l-46,45.5a4.42,4.42,0,0,0-.88,5.07l23.34,48.61a235.25,235.25,0,0,0-29.51,70.2l-51.1,17.3a4.43,4.43,0,0,0-3,4.17l-.36,64.72a4.44,4.44,0,0,0,3,4.21L1628,478.82a235.17,235.17,0,0,0,28.72,70.52l-23.88,48.34a4.43,4.43,0,0,0,.82,5.08l45.51,46a4.42,4.42,0,0,0,5.07.88l48.6-23.34a235.07,235.07,0,0,0,70.2,29.5l17.3,51.11a4.45,4.45,0,0,0,4.18,3l64.72.36a4.42,4.42,0,0,0,4.2-3l17.88-50.91a235.28,235.28,0,0,0,70.52-28.72l48.34,23.88a4.43,4.43,0,0,0,5.08-.82l46-45.51a4.45,4.45,0,0,0,.88-5.07l-23.35-48.6a235.1,235.1,0,0,0,29.51-70.2l51.1-17.31a4.43,4.43,0,0,0,3-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1899.86,375.82a65.08,65.08,0,1,1-7.8-5.53A66.66,66.66,0,0,1,1899.86,375.82Zm-73.28,88.55a49.87,49.87,0,1,0-16.6-26.46A49.52,49.52,0,0,0,1826.58,464.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1958.64,302.51a164.35,164.35,0,0,1,12.14,11.09h0c1.22,1.23,2.42,2.49,3.6,3.76a160.29,160.29,0,0,1,15.87,20.11l.2.29.54.83c.35.53.7,1.07,1,1.61a3.8,3.8,0,0,1-.27,4.46,3.54,3.54,0,0,1-.89.78,3.79,3.79,0,0,1-5.23-1.16,152.51,152.51,0,0,0-235.74-26.55q-5.61,5.56-10.58,11.58a152.39,152.39,0,0,0,9.38,203.9c59.11,59.76,155.74,60.28,215.48,1.2a152.33,152.33,0,0,0,40.45-70.36,3.79,3.79,0,1,1,7.35,1.88,160.49,160.49,0,0,1-42.46,73.88c-62.72,62-164.22,61.43-226.22-1.26a160,160,0,0,1-9.84-214.06,162.63,162.63,0,0,1,11.1-12.15,160,160,0,0,1,214.08-9.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2692.75,598.65a6.87,6.87,0,0,1,1.94,8c-2.3,5.36-4.79,10.73-7.4,15.94a6.87,6.87,0,1,1-12.28-6.15c2.49-5,4.86-10.08,7-15.2a6.87,6.87,0,0,1,9-3.61A6.73,6.73,0,0,1,2692.75,598.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2667.58,645.11a6.87,6.87,0,0,1,1.34,9.11,300.37,300.37,0,0,1-18,24.25q-2,2.44-4.1,4.86a7.11,7.11,0,0,1-9.69.73,6.87,6.87,0,0,1-.73-9.69q2-2.31,3.92-4.64a286.86,286.86,0,0,0,17.2-23.13,6.88,6.88,0,0,1,9.53-1.91Zm-46.55,54a5.68,5.68,0,0,1,.71.68,6.86,6.86,0,0,1-.46,9.7,296.37,296.37,0,0,1-28.51,22.9,6.87,6.87,0,0,1-7.92-11.23A284.21,284.21,0,0,0,2612,699.37,6.87,6.87,0,0,1,2621,699.15Zm-58.27,41.13a6.88,6.88,0,0,1-1.14,11.36,298.06,298.06,0,0,1-33.29,15.19,6.87,6.87,0,0,1-4.92-12.83,282.87,282.87,0,0,0,31.74-14.49A6.89,6.89,0,0,1,2562.76,740.28Zm-66.6,25.55a6.87,6.87,0,0,1-2.73,12,297.77,297.77,0,0,1-36,6.58,6.87,6.87,0,0,1-1.63-13.64,282.6,282.6,0,0,0,34.31-6.28A6.87,6.87,0,0,1,2496.16,765.83Zm-70.82,8.5a6.88,6.88,0,0,1-4.39,12.18,302.34,302.34,0,0,1-36.48-2.36,6.87,6.87,0,1,1,1.72-13.63,284.9,284.9,0,0,0,34.8,2.24A6.91,6.91,0,0,1,2425.34,774.33Zm-70.73-8.93a6.87,6.87,0,0,1-6.06,12,298,298,0,0,1-34.8-11.18,6.87,6.87,0,0,1,5-12.8A282.74,282.74,0,0,0,2351.93,764,6.81,6.81,0,0,1,2354.61,765.4Zm-66.38-25.95a6.87,6.87,0,0,1-7.65,11.33,299,299,0,0,1-31-19.39,6.87,6.87,0,0,1,8-11.18,283.58,283.58,0,0,0,29.57,18.49A6.65,6.65,0,0,1,2288.23,739.45Zm-82.8-67.22a6.89,6.89,0,0,1,.86.85,284.53,284.53,0,0,0,20.87,22c1.11,1.06,2.21,2.1,3.33,3.11a6.88,6.88,0,0,1,.42,9.71,6.81,6.81,0,0,1-9.71.42c-1.18-1.09-2.35-2.18-3.52-3.29A298.56,298.56,0,0,1,2195.83,682a6.87,6.87,0,0,1,9.6-9.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2607.62,258.46a6.87,6.87,0,0,1-8.68,10.65,283.63,283.63,0,0,0-28-19.83,6.87,6.87,0,1,1,7.25-11.67,298.06,298.06,0,0,1,29.34,20.79Zm26,23.62c.19.16.37.33.55.51a299.92,299.92,0,0,1,23.55,27.19,6.87,6.87,0,0,1-10.91,8.36,284.27,284.27,0,0,0-22.47-25.95,6.87,6.87,0,0,1,9.28-10.11ZM2548,221.46a6.87,6.87,0,0,1-7.26,11.53,284.21,284.21,0,0,0-32-12.48,6.87,6.87,0,0,1,4.22-13.08,296.76,296.76,0,0,1,33.5,13.09A6.78,6.78,0,0,1,2548,221.46Zm128.24,116.36a7,7,0,0,1,1.55,1.82,295.57,295.57,0,0,1,16.3,32.09,6.87,6.87,0,1,1-12.61,5.46A281.51,281.51,0,0,0,2666,346.6a6.87,6.87,0,0,1,10.3-8.78ZM2481.28,200a6.87,6.87,0,0,1-5.67,12,281.74,281.74,0,0,0-34-4.43,6.87,6.87,0,1,1,1-13.71,298.82,298.82,0,0,1,35.66,4.64A6.89,6.89,0,0,1,2481.28,200Zm-70-4.86a6.87,6.87,0,0,1-4,12.16,286,286,0,0,0-34.1,3.83,6.87,6.87,0,1,1-2.36-13.53,299.15,299.15,0,0,1,35.75-4A6.88,6.88,0,0,1,2411.31,195.1Zm-69.12,12.05a6.75,6.75,0,0,1,2.19,3.31,6.85,6.85,0,0,1-4.58,8.56,280.76,280.76,0,0,0-32.19,11.9,6.87,6.87,0,0,1-5.54-12.58,298.58,298.58,0,0,1,33.76-12.48A6.84,6.84,0,0,1,2342.19,207.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2704.28,402.52a6.81,6.81,0,0,1,2.21,3.36c1.66,5.64,3.16,11.35,4.46,17a6.87,6.87,0,0,1-13.39,3.09c-1.24-5.37-2.67-10.82-4.25-16.2a6.87,6.87,0,0,1,11-7.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2643.39,467.32a3.48,3.48,0,0,0-2.33-3.3l-39.94-14a184.38,184.38,0,0,0-22.54-55.34l18.74-37.93a3.47,3.47,0,0,0-.64-4L2561,316.64a3.47,3.47,0,0,0-4-.69l-38.14,18.32a184.2,184.2,0,0,0-55.08-23.16L2450.2,271a3.49,3.49,0,0,0-3.28-2.37l-50.78-.28a3.48,3.48,0,0,0-3.3,2.33l-14,39.94a184.38,184.38,0,0,0-55.34,22.54l-37.93-18.74a3.47,3.47,0,0,0-4,.64l-36.11,35.71a3.47,3.47,0,0,0-.69,4l18.32,38.13A184.41,184.41,0,0,0,2239.93,448l-40.09,13.58a3.48,3.48,0,0,0-2.37,3.27l-.28,50.79a3.49,3.49,0,0,0,2.33,3.3l39.94,14A184.32,184.32,0,0,0,2262,588.27l-18.74,37.93a3.48,3.48,0,0,0,.64,4l35.71,36.11a3.49,3.49,0,0,0,4,.69l38.13-18.32a184.39,184.39,0,0,0,55.08,23.15l13.58,40.1a3.46,3.46,0,0,0,3.28,2.36l50.77.29a3.49,3.49,0,0,0,3.31-2.33l14-39.94a184.32,184.32,0,0,0,55.33-22.54L2555,668.5a3.48,3.48,0,0,0,4-.64l36.11-35.71a3.49,3.49,0,0,0,.69-4L2577.49,590A184.22,184.22,0,0,0,2600.64,535l40.1-13.58a3.49,3.49,0,0,0,2.37-3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2453.45,451.46a52,52,0,1,1-6.28-4.46A53.42,53.42,0,0,1,2453.45,451.46Zm-57.51,69.48a38.82,38.82,0,0,0,4.58,3.24,38.22,38.22,0,1,0,39.54-65.42h0a38.22,38.22,0,0,0-44.12,62.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2501.51,391.69a130.08,130.08,0,0,1,26.26,29.4c.22.33.43.66.64,1a6.87,6.87,0,1,1-11.58,7.38,116.1,116.1,0,0,0-15.37-19.24h0c-.31-.32-.64-.64-1-1a114.53,114.53,0,0,0-48.78-28.78,116.9,116.9,0,0,0-30.81-4.59h-1a114.94,114.94,0,0,0-82,33.42,116.59,116.59,0,0,0-8,8.79,115.67,115.67,0,1,0,201.39,102.28,6.73,6.73,0,0,1,1.36-2.66,6.87,6.87,0,0,1,12,6.08,129.15,129.15,0,0,1-25.48,50.06,130.87,130.87,0,0,1-8.86,9.7,129.41,129.41,0,0,1-191-174.19q4.22-5.1,9-9.83C2375.81,352.49,2451,350,2501.51,391.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 73.34,
    y: 682.94,
    width: 2756.09,
    height: 1429.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 94.67,
    y: 682.94,
    width: 2709.16,
    height: 1390.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2828.84,601.87H78.41c-18.78,0-37.79,15.71-37.79,35.08V679c0,9.36,5.52,18.33,12,24.92a35.65,35.65,0,0,0,25.21,10.16l2748.43-26.74c18.66-.18,31.69-15.83,31.69-35.08V637C2857.91,617.58,2847.63,601.87,2828.84,601.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2831.47,2056.71H81.93c-18.79,0-37.79,18-37.79,37.35v42.07c0,9.36,5.52,18.34,12,24.92a35.64,35.64,0,0,0,25.2,10.16l2747.54-26.73c18.66-.19,31.69-15.84,31.69-35.08v-15.34C2860.53,2074.68,2850.25,2056.71,2831.47,2056.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2700.46,764.8,177,750.09c-10.58-.06-22.7,4.1-30.2,11.56s-13.68,17.6-13.68,28.18V1992.67c0,21.95,21.77,38.45,43.72,38.45H2700.36c21.95,0,39.48-16.5,39.48-38.45V804.55A39.64,39.64,0,0,0,2700.46,764.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M954.09,791.31,1835,773.36a16,16,0,0,1,16.34,16.17l-.13,14.18a16,16,0,0,1-16,15.86l-880.8,3.76a16,16,0,0,1-16.08-16.17h0A16,16,0,0,1,954.09,791.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M937.69,881l-.05,6a16,16,0,0,0,15.86,16.17l880.68,8.4a16,16,0,0,0,16.17-15.86l.06-6a16,16,0,0,0-15.87-16.17l-880.68-8.4A16,16,0,0,0,937.69,881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1204.24,962.5l0,2.65a16,16,0,0,0,15.86,16.17l613.38,5.85a16,16,0,0,0,16.17-15.86l.12-12.47a16,16,0,0,0-16.12-16.16l-613.48,4A16,16,0,0,0,1204.24,962.5Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 219.68,
    y: 1215.8,
    width: 147.3,
    height: 761.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 465.8,
    y: 1215.8,
    width: 147.3,
    height: 761.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 711.92,
    y: 1215.8,
    width: 147.3,
    height: 761.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 958.04,
    y: 1215.8,
    width: 147.3,
    height: 761.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1204.16,
    y: 1215.8,
    width: 147.3,
    height: 761.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1450.28,
    y: 1215.8,
    width: 147.3,
    height: 761.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1696.4,
    y: 1215.8,
    width: 147.3,
    height: 761.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 219.68,
    y: 1578.74,
    width: 147.3,
    height: 398.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 465.8,
    y: 1715.69,
    width: 147.3,
    height: 261.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 711.92,
    y: 1377.23,
    width: 147.3,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 958.04,
    y: 1833.08,
    width: 147.3,
    height: 144.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1204.16,
    y: 1457.44,
    width: 147.3,
    height: 519.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1450.28,
    y: 1843.22,
    width: 147.3,
    height: 134
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1696.4,
    y: 1645.26,
    width: 147.3,
    height: 331.96
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2128.38,1764.25H1948.82a20.41,20.41,0,0,0,0,40.81h179.56a20.41,20.41,0,1,0,0-40.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2402.24,1764.25H2222.67a20.41,20.41,0,0,0,0,40.81h179.57a20.41,20.41,0,0,0,0-40.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2496.52,1805.06h179.57a20.41,20.41,0,0,0,0-40.81H2496.52a20.41,20.41,0,0,0,0,40.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1928.42,
    y: 1827.74,
    width: 220.38,
    height: 160.99,
    rx: 20.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2202.27,
    y: 1827.74,
    width: 220.38,
    height: 160.99,
    rx: 20.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2476.12,
    y: 1827.74,
    width: 220.38,
    height: 160.99,
    rx: 20.41
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1901.52,
    y: 1471.47,
    width: 786.31,
    height: 237.78,
    rx: 11.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1945.96,
    y: 801.43,
    width: 342.78,
    height: 617.24,
    rx: 13.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2321.21,
    y: 801.43,
    width: 342.78,
    height: 617.24,
    rx: 13.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M416.42,2757.28s-6.25,33.51-9.48,66.72a22.9,22.9,0,0,0,21.67,25c44.23,2.27,138.86,6.75,172.84,5.56a7.45,7.45,0,0,0,6.65-10.14h0a16.7,16.7,0,0,0-8.44-9.07L444,2762Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M411.75,2737.51l4.38,40.2s27.27,13,46.11-1.17l-10.92-44.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M422.53,1982.64c-2.16,10.47-16,523.17,36.58,753.49a7.81,7.81,0,0,1-4.66,9,135.85,135.85,0,0,1-44.73,8.64,13.42,13.42,0,0,1-13.23-9.77c-15.16-53.46-87.69-321.31-95.05-576.58-8.23-285.25.09-9.71.09-9.71l8.1-176.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M236.38,2773.08s-9.6,16.85-19.16,61.8a14,14,0,0,0,12.13,16.85c14.6,1.57,37.07,3.63,55.09,3.68a13.93,13.93,0,0,0,13.94-15.4c-1.84-16.46-7.8-43.49-26.81-64.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M228.59,2721.35l10.55,60.83s10.93,8.29,32.76,2.57l-4.69-65.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M205.43,1996.31c-47.41,270.12,3.34,668.78,21,746.88a12.15,12.15,0,0,0,9.72,9.32c8.2,1.44,21.71,2.68,35.08-1.07a11.14,11.14,0,0,0,8.1-10.18c3.07-63,2.32-449.77,45.55-602.22a34.7,34.7,0,0,1,13.57-19l81.63-56.86,7.1-93.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M496,1486.39c-134.32-3.5-282.91,32.58-282.91,32.58-42.28,233.28-11.81,503.12-11.81,503.12,103.75,28.26,221.5-14.57,221.5-14.57,18.21-97.5,101.49-371.6,101.49-371.6,65.72-7.52,120-25.94,164.74-50.55-33.59-39.7-49.12-89.95-55.79-119.63C585.54,1480.05,537.4,1487.47,496,1486.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M894.7,1292.29c-13.05-16.06-29.83-8.68-29.83-8.68-20.56,83.32-124.87,150.05-231.68,182.13,6.67,29.68,22.2,79.93,55.79,119.63C866.68,1487.68,894.7,1292.29,894.7,1292.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M891.45,1296.32c1.34,4.4-14.71,10.93-24-7.11-.24-8.61-5.13-45.53.08-52.49,27.75-37.07,81.29-83.37,81.29-83.37,8.89,8.94,1.41,17.57,1.41,17.57l-26,26.59c5.29,9.78,11.79,18.06,14.75,29.87a36.09,36.09,0,0,1-3.85,26.53c-4.6,8.1-10.87,18.63-16.78,26.86C907.19,1296.35,891.45,1296.32,891.45,1296.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M912.83,1214.81l-23.67,19.67-7.55,19.74,20.7,23.42s7.41-39.24,12.72-47.7S917.67,1217.34,912.83,1214.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M263.34,1649.55,213.06,1519s-126.3,84.07-148,192c23.69,2,66.78,8.56,108.81,30.28C183.66,1690.27,263.34,1649.55,263.34,1649.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M371.84,1773s-141.65,78.28-188.54,9.84c-9.74-14.21-12-28.26-9.4-41.62-42-21.72-85.12-28.3-108.81-30.28-6.54,32.53-3.58,67.23,15.24,102.44,81.82,153.12,309.82-5.46,309.82-5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M360.93,1376,317,1499.24a4.44,4.44,0,0,0,2,5.38c11.59,6.56,53.39,25.58,104.29-6a21,21,0,0,0,9.8-14.89l14.86-106.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M455,1262.44s46.09,88.81,39.74,124.44-64.51,32.52-115,3l-34.58-95.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M382.44,1343.09a3.64,3.64,0,0,0,1.64-5.31c-3.71-5.78-10.65-17.57-12.8-27.86,0,0-8.39-5.48,21.6-12.36s74.7-17.56,84.32-42.93c9.38-24.74-14-87.41-52.84-38a3.64,3.64,0,0,1-5.77,0c-6.21-8.24-22.56-25.37-45.59-15.3-21.56,9.43-24.12,25.13-23.9,33.06a3.62,3.62,0,0,1-4.33,3.66c-10.83-2.17-36.85-4.19-49.26,22.4-10.22,21.9-3.83,34.42,2,40.57a3.63,3.63,0,0,1-1.61,6c-7.16,2.12-16.42,8.07-15.66,24.79,1.06,23.11,26.9,21.32,34.26,20.34a3.6,3.6,0,0,1,3.22,1.17c6.24,7,34.36,36.93,65.06,40.79a3.67,3.67,0,0,0,3.9-4.82l-12.93-38.79a3.67,3.67,0,0,1,2-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M387.73,1348.63s-33.2-23.25-35.83-4,29.83,28.26,46,21.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M342.89,1896.72l77.16-269.47a7.87,7.87,0,0,1,6.65-5.66c14-1.63,54.49-6.21,101.26-10.17,56.34-4.76,121.77-8.62,160.86-5.34a7.89,7.89,0,0,1,6.45,11.35c-22.23,45-113.69,227.94-159.48,287.88a7.92,7.92,0,0,1-6.36,3.13l-179-1.67A7.89,7.89,0,0,1,342.89,1896.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M361.53,1831.61s-10.75-44.2-6.41-59.88,12.74-35.84,40.74-31.36,61,16.28,61,16.28-1.67,20.42-22.95,13.83l13.2,10.21s-1.89,16.36-19.87,7.62l12.28,13.54s-7.72,13.43-20.95,4.82S399,1836.93,361.53,1831.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M522.82,1691.86a22.65,22.65,0,1,0,22.65-22.65A22.65,22.65,0,0,0,522.82,1691.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M428.78,1706.8l-5.77-1.71,15.71-53.29a24.27,24.27,0,0,1,18.28-17c49.79-10.4,181-12.52,186.5-12.6l.1,6c-1.36,0-136.14,2.2-185.37,12.47a18.28,18.28,0,0,0-13.74,12.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1643.83,
    y: 2485.6,
    width: 30.23,
    height: 326.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1791.32,2818.79H1526.58a19.67,19.67,0,0,1,19.67-19.68h225.39a19.68,19.68,0,0,1,19.68,19.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1497.75,
    y: 2412.36,
    width: 332.86,
    height: 94.4,
    rx: 32.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1435.8,2267.64s-44.92,7-95.42,40.73a25.15,25.15,0,0,0-11.11,24.05c6,47.9,30.91,202.94,112.9,354.36a38.17,38.17,0,0,1,3.66,26.15l-14.25,66.29L1405.17,2804h68l45.3-122.6-19.37-6.12a36.65,36.65,0,0,1-25.6-34.31l-2.27-131.51c1.94-58.59-35.93-99-35.93-99l108.66-5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1378.6,2816c-6.2,8.11,66.69,18.81,103.51,1.07,0,0,51.05-88.81,51.05-134.54,0,0-4.05-9.32-34-7.21,0,0-17.14,105.16-35.24,116.94s-50.64,1.19-50.64,1.19S1387.74,2804,1378.6,2816Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1530.25,2412.36c-.58-1-117-14-117-14s3.81,35.4-8.09,84.12-182.83,259.82-182.83,259.82l17.93,56.81c-55.41,19.31-109.92,22.39-163.55,9.84l111.06-66.65s103.94-354.21,167.61-417.4l116.69-40.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1791.32,2206.25s67.07,99.76,72.57,145.26-18.37,64-88.74,67-258.24,3-258.24,3l-160.35-137s116.85-41.7,147.24-53.49S1791.32,2206.25,1791.32,2206.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1233.49,2780s19.3,18.69,6.26,39.48c0,0-152.84,27.09-194.33,14.8,0,0,8.61-19.67,55.34-42.05l-3.45,2.64a5.59,5.59,0,0,0,3.69,10C1131.79,2803.11,1195.51,2797.47,1233.49,2780Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1585.48,1526.84c131.7,44.66,135.34,173.72,120,192.15a4.3,4.3,0,0,0,2.39,6.89c15.86,3.76,49,15.59,55.12,49.6,5.4,30-17.8,43.06-33.88,48.41a4.33,4.33,0,0,0-.3,8.16c27.2,10.54,82.94,39.66,64,96.37-17.67,52.89-58.67,48.35-80.7,41.41a4.3,4.3,0,0,0-5,6.25c6.54,11.69,11,31-7.55,54.19-29.11,36.42-106.45-9.64-115.41-15.16a4.23,4.23,0,0,1-1.38-1.38L1495.1,1873a4.31,4.31,0,0,1-.43-3.67l54.25-161.58a4.32,4.32,0,0,1,2.79-2.75l-19.63-161.23C1504.47,1523.12,1583.93,1526.31,1585.48,1526.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1609.94,2165.86s-78.1-74.37-116.55-123.63a104.51,104.51,0,0,1-17.7-94.06c17.55-59.13,48.75-120.38,51.59-129.91,4.36-14.61,91.94-14,91.94-14s172.32,111.84,240,301.29l-76,23.67s-45-75.48-89.45-123.48c0,0,76.93,101.63,79.63,143.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1516.16,1728.92c.92,3,24.3,86.49,26.09,88.07s50.13,4.17,72.88-11.38l-56.44-110.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1484.9,1565.09s-36.58,25.85-51.22,90.1,11.72,86.66,38.24,84.72,64.84-10.93,97.26-57.47S1532.88,1533.43,1484.9,1565.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1535,1657.34s11.73-91.88-64-76.33l-15,16.32s-38.08-41.17,2.48-73.7,97.89-25.56,130.68,31.49,45.09,97.37,19.31,133.75-46.35,6-46.35,6,11.53-31.27,1.17-44.38-22.94,8.21-22.94,8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1527.75,1677s5.76-47.26,30.1-34.28-7.78,44.21-20.7,54.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1450.82,2171.38l57.39-55.31,79.38,33.54s79,12.24,124.24,0l45.22-12.24,102.2-31.82,16,45.36a27.31,27.31,0,0,1-10,31.38c-8.84,6.28-19.2,13.19-25.81,16.08-13.46,5.89-331.76-4.08-331.76-4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1668,2194.06l-.76,0-332.87-.37a14.9,14.9,0,1,1,0-29.79l332.87.36a14.9,14.9,0,0,1,.73,29.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1035.11,1891.83h277.22a52.83,52.83,0,0,1,47.78,30.3l128.16,271.75H1143.76a32.11,32.11,0,0,1-29.86-20.31l-99.38-251.46A22.14,22.14,0,0,1,1035.11,1891.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1230.41,2031.17c6,18.66,1.57,36.79-9.91,40.49s-25.66-8.44-31.67-27.11-1.57-36.79,9.92-40.48S1224.4,2012.51,1230.41,2031.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2464.2,2845.53a10.83,10.83,0,0,0,4.63-1c5.94-2.79,8.69-10.32,6.13-16.81l-245.78-623.63c-2.56-6.49-9.45-9.49-15.4-6.7s-8.69,10.32-6.13,16.81l245.78,623.63A11.74,11.74,0,0,0,2464.2,2845.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2187.32,2845.53a11.74,11.74,0,0,0,10.77-7.74l245.78-623.63c2.56-6.49-.19-14-6.13-16.81s-12.84.21-15.4,6.7l-245.78,623.63c-2.56,6.49.18,14,6.13,16.81A10.83,10.83,0,0,0,2187.32,2845.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1188.87,2847.22a10.83,10.83,0,0,0,4.63-1c5.94-2.79,8.69-10.32,6.13-16.81L953.85,2205.74c-2.56-6.49-9.44-9.49-15.4-6.7s-8.69,10.32-6.13,16.81l245.78,623.63A11.74,11.74,0,0,0,1188.87,2847.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M912,2847.22a11.74,11.74,0,0,0,10.77-7.74l245.78-623.63c2.56-6.49-.18-14-6.13-16.81s-12.84.21-15.4,6.7L901.23,2829.37c-2.56,6.49.19,14,6.13,16.81A10.83,10.83,0,0,0,912,2847.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M856.12,2184.76a12.28,12.28,0,0,1,3.56-11.56,18.52,18.52,0,0,1,13.05-5.09h1710c6.64,0,12.82,2.8,16.4,7.43a13.76,13.76,0,0,1,1.27,15.43l-18.53,33.19c-4.25,7.59-13.44,12.46-23.56,12.46H884.46c-9.41,0-17.5-5.52-19.29-13.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 288.19,
    cy: 656.74,
    r: 150.92,
    transform: "translate(-379.97 396.14) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M288.19,751.38a94.64,94.64,0,1,1,94.65-94.64A94.75,94.75,0,0,1,288.19,751.38Zm0-173.42A78.78,78.78,0,1,0,367,656.74,78.87,78.87,0,0,0,288.19,578Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M258.54,693.19v-68a9.38,9.38,0,0,1,14.17-8.07l57.33,34a9.37,9.37,0,0,1,0,16.13l-57.33,34A9.38,9.38,0,0,1,258.54,693.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 717.98,
    cy: 413.21,
    r: 144.11,
    transform: "translate(-81.89 628.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M715.72,320a65.88,65.88,0,0,0-65.88,65.88c0,23.58,27.66,78.43,47.14,114.12a21.34,21.34,0,0,0,37.48,0c19.47-35.69,47.14-90.54,47.14-114.12A65.89,65.89,0,0,0,715.72,320Zm0,101.25a35.37,35.37,0,1,1,35.37-35.37A35.36,35.36,0,0,1,715.72,421.27Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 609.21,
    cy: 1016.77,
    r: 156.57,
    transform: "translate(-540.53 728.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 609.21,
    cy: 1016.77,
    r: 151.36,
    transform: "translate(-540.53 728.59) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M607.42,1153.25c-70.09,0-127.43-58.94-128.08-132-.65-73.45,56.28-133.75,126.92-134.43,34.21-.31,66.51,13.22,90.93,38.14s38,58.25,38.36,93.83-12.72,69.16-36.69,94.55-56,39.56-90.24,39.88Zm0-256.22h-1.11c-65.23.63-117.81,56.32-117.21,124.15.6,67.44,53.56,121.88,118.29,121.88h1.1c65.24-.63,117.82-56.32,117.21-124.15C725.14,951.47,672.18,897,607.46,897Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M600.85,1115.39l-.13-13.93c-14.53-.45-28.94-3.75-39.18-8.12a8.07,8.07,0,0,1-4.55-9.49l3.42-13a8.13,8.13,0,0,1,11-5.42,94.42,94.42,0,0,0,36.17,7.27c14-.13,24.39-5,24.3-14.7-.08-8.77-8.19-13.91-27.69-19-27.82-7.34-47.86-19.25-48.08-43.68-.21-22.06,15.77-39.05,43.71-43.81l-.13-13.94a8.12,8.12,0,0,1,8.05-8.2l8.19-.07a8.12,8.12,0,0,1,8.19,8l.12,12.52a103.42,103.42,0,0,1,31,5.28,8.09,8.09,0,0,1,5.14,9.71l-3.15,12a8.1,8.1,0,0,1-10.64,5.57,84.51,84.51,0,0,0-30.45-5.24c-16.6.15-21.28,7.08-21.23,13.24.07,7.59,10.08,12.72,31.73,19.16,30.92,9,43.84,21.66,44.06,44.66.19,21.11-15.29,40.23-45.6,45.26l.14,15.6a8.12,8.12,0,0,1-8,8.19l-8.19.08A8.12,8.12,0,0,1,600.85,1115.39Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugarImg2);
export default __webpack_public_path__ + "static/media/sugar_img_2.331d8630f656301b98d61861acef435f.svg";
export { ForwardRef as ReactComponent };